/**
 * Transition Rules: EnergyPlus 9.6 to 22.1
 *
 * Note: Version numbering changed from 9.6 to 22.1 (year-based versioning)
 * This transition has minimal object changes.
 */

import type { VersionTransition, ObjectTransitionRule } from '../types';
import { createCopyMappings, createShiftedCopyMappings } from '../types';

export function createTransition_9_6_to_22_1(): VersionTransition {
  const objectRules = new Map<string, ObjectTransitionRule>();
  const variableMappings = new Map<string, string>();
  const deletedObjects = new Set<string>();
  const renamedObjects = new Map<string, string>();

  // PythonPlugin:SearchPaths - Insert 'Yes' at field 4
  objectRules.set('PYTHONPLUGIN:SEARCHPATHS', {
    sourceClass: 'PythonPlugin:SearchPaths',
    targetClass: 'PythonPlugin:SearchPaths',
    fieldMappings: [
      ...createCopyMappings(0, 3), // Fields 0-2
      { sourceIndex: -1, targetIndex: 3, type: 'add_default', defaultValue: 'Yes' },
      ...createShiftedCopyMappings(3, 4, 20),
    ],
  });

  return {
    fromVersion: { major: 9, minor: 6 },
    toVersion: { major: 22, minor: 1 },
    objectRules,
    variableMappings,
    deletedObjects,
    renamedObjects,
  };
}
